import React, { useState } from 'react';
import { string, bool, number, oneOfType } from 'prop-types';
import { get } from 'lodash';
import { Menu as AntMenu } from 'antd';
import Link from '../../routes/Link';
import { OrderEventsConsumer } from '../../firebase/OrderEvents';
import GetUserSalesChannels from '../../graphql/getUserSalesChannels';
import { InvoicingDateRangeContext } from '../../contexts/InvoicingDateRange';
import { Query } from '../../graphql';
import GET_COUNT_ORDERS from '../../../queries/GET_COUNT_ORDERS';
import { withReloadable } from '../../../hoc';
import { HasPermissions, Text, IconBadge, If } from '../../common';

const InvoicingItem = withReloadable(({ init, end, salesChannels, icon, itemColor, ts }) => {
    return (
        <GetUserSalesChannels>
            {({ data }) => {
                const QUERY_VARIABLES = {
                    range: {
                        filter: 'shippingETA.init',
                        init,
                        end
                    },
                    filters: [
                        {
                            field: 'status',
                            value: ['9']
                        },
                        {
                            field: 'salesChannel',
                            value: salesChannels
                        }
                    ]
                };

                return (
                    <Query query={GET_COUNT_ORDERS} variables={QUERY_VARIABLES} ts={ts}>
                        {({ data }) => {
                            const count = get(data, 'getCountOrders.count', 0);
                            return <IconBadge name={icon} count={count} color={itemColor} backgroundColor='#cc444b' />;
                        }}
                    </Query>
                );
            }}
        </GetUserSalesChannels>
    );
}, ['ts']);

const InvoicingMenuItem = ({ collapsed, icon, label, index, path, currentPathname, ...props }) => {
    const [hovered, toggleHover] = useState(false);
    const isActive = currentPathname === path;
    const itemColor = isActive || hovered ? '#1fa02e' : '#ffffff';

    return (
        <AntMenu.Item
            className='ant-menu-item'
            key={`invoicing-menu-item-${index}`}
            onClick={() => this.props.navigate('/invoicing-monitor')}
            title={<Text text={label} color='white' />}
            onMouseEnter={() => toggleHover(!hovered)}
            onMouseLeave={() => toggleHover(!hovered)}
            {...props}
        >
            <Link href='/invoicing-monitor' style={{ display: 'flex' }}>
                <OrderEventsConsumer>
                    {({ ts }) => (
                        <InvoicingDateRangeContext.Consumer>
                            {({ init, end, salesChannels }) => {
                                const properties = { init, end, salesChannels };
                                return <InvoicingItem icon={icon} ts={ts} itemColor={itemColor} {...properties} />;
                            }}
                        </InvoicingDateRangeContext.Consumer>
                    )}
                </OrderEventsConsumer>
                <If
                    condition={!collapsed}
                    then={
                        <Text
                            color={itemColor}
                            text={label}
                        />
                    }
                />
            </Link>
        </AntMenu.Item>
    );
};

InvoicingMenuItem.propTypes = {
    icon: string,
    label: string,
    index: oneOfType([number, string]),
    collapsed: bool,
    path: string,
    currentPathname: string
};
export default InvoicingMenuItem;
